import { getApplicationUrl } from 'service/env'

const buildSupplierJourneyUrl = (token, organizationSlug = 'dponet') =>
  `${getApplicationUrl()}/${organizationSlug}/suppliers/${token}/journey`

export default buildSupplierJourneyUrl
